import * as React from 'react';
export const IcBroom = (props: React.SVGProps<SVGSVGElement>): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M2.84 12a1 1 0 00-.55 1.7l1 1A1 1 0 004 15h1v1a1 1 0 00.29.71l5 5a1 1 0 001.02.24 1 1 0 00.68-.79l.7-4.23-5.62-5.62-4.23.69zm18.57-9.41a2 2 0 00-2.82 0l-7.3 7.29-.58-.59a1.004 1.004 0 10-1.42 1.42l4 4a1.002 1.002 0 001.64-.326 1.002 1.002 0 00-.22-1.094l-.59-.58 7.29-7.3a2 2 0 000-2.82z'
      fill='currentColor'
    />
  </svg>
);
